import DashboardReducer from "./reducers/DashboardSlice";
import { combineReducers, configureStore, createStore } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  DashboardReducer,
});

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
